'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/~/react-dom/index.js
// module id = 2111
// module chunks = 0